import React, {useState, useEffect} from 'react'
import {useCustomerType} from '@salesforce/commerce-sdk-react'
import {Box, useBreakpointValue, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import useFetchLibraryFolders from '../../hooks/useFetchLibrary'
import {contentStyle} from './index.style'
import {TrackOrderModal, useTrackOrderModal} from '../../hooks/use-track-order-modal'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const LeftNav = () => {
    const {
        data: {folders = []},
        loading
    } = useFetchLibraryFolders('folders/customer-service')
    const isMobile = useBreakpointValue({base: true, md: false})
    const trackOrderModal = useTrackOrderModal()
    const navigate = useNavigation()
    const {buildUrl} = useMultiSite()
    const {isRegistered} = useCustomerType()

    const [activeIndexes, setActiveIndexes] = useState({})

    const handleTrackOrderClick = (name) => (e) => {
        if (name === 'Track Orders') {
            e?.stopPropagation()
            e?.preventDefault()
            if (isRegistered) {
                const path = buildUrl('/account/orders')
                navigate(path)
            } else {
                trackOrderModal.onOpen()
            }
        }
    }
    useEffect(() => {
        if (isMobile) {
            if (Object.keys(activeIndexes).length > 0) {
                setActiveIndexes({})
            }
        } else {
            if (Object.keys(activeIndexes).length !== folders.length) {
                const allOpen = {}
                folders?.forEach((_, index) => {
                    allOpen[index] = true
                })
                setActiveIndexes(allOpen)
            }
        }
    }, [isMobile, folders])

    const toggleAccordion = (index) => {
        setActiveIndexes((prevState) => ({
            ...prevState,
            [index]: !prevState[index]
        }))
    }

    return (
        <Box sx={loading ? {display: 'none'} : contentStyle}>
            {folders.length > 0 && (
                <Box className="leftnav-container">
                    {folders?.map((folder, index) => {
                        const isActive = activeIndexes[index]
                        return (
                            <Box key={folder.id} className="leftnav-accordion-item">
                                <h3
                                    role="button"
                                    className="leftnav-accordion-title"
                                    onClick={() => toggleAccordion(index)}
                                >
                                    {folder.name}
                                    <span className="leftnav-accordion-title-btn">
                                        {isActive ? '-' : '+'}
                                    </span>
                                </h3>
                                {isActive && folder.c_contentAssets?.length > 0 && (
                                    <Box className="leftnav-accordion-content">
                                        <ul>
                                            {folder.c_contentAssets.map(
                                                ({id, name, alternativeURL, URL}) => {
                                                    return (
                                                        <li key={id}>
                                                            {alternativeURL ? (
                                                                <Link
                                                                    href={alternativeURL}
                                                                    title={name}
                                                                    onClick={handleTrackOrderClick(
                                                                        name
                                                                    )}
                                                                >
                                                                    {name}
                                                                </Link>
                                                            ) : (
                                                                <Link
                                                                    to={URL}
                                                                    as={RouteLink}
                                                                    title={name}
                                                                >
                                                                    {name}
                                                                </Link>
                                                            )}
                                                        </li>
                                                    )
                                                }
                                            )}
                                        </ul>
                                    </Box>
                                )}
                            </Box>
                        )
                    })}
                </Box>
            )}
            <TrackOrderModal {...trackOrderModal} />
        </Box>
    )
}

export default LeftNav
